<template>
  <input
    :value="value"
    @input="updateValue"
    v-bind="$attrs"
    type="text"
    class="
      block
      w-full
      rounded-md
      border-gray-300
      shadow-sm
      focus:ring-cyan-500 focus:border-cyan-500
    "
    placeholder="ค้นหา"
  />
</template>

<script>
export default {
  name: 'SearchWidgetResultsList',

  inheritAttrs: false,

  props: {
    value: [String, Number],
  },

  methods: {
    updateValue(event) {
      this.$emit('input', event.target.value)
    },
  },
}
</script>
